module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "forms-ai-lib": "static-1.1174"
    },
    "depPathPrefixes": {
      "forms-ai-lib": "/forms-ai-lib/static-1.1174"
    },
    "project": "forms-ai-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};